import { createDateFormatter } from '@polaris/core/utils'
import { queryOptions } from '@tanstack/react-query'
import {
  type GetAssetMarketChartRawResponse,
  type GetAssetMarketChartRequest,
  type GetAssetMarketChartResponse,
  getAssetMarketChart,
} from '@/src/services/token-info/asset-market-chart'

const ASSET_MARKET_CHART_DATA_KEY = 'token-info-asset-market-chart-data'

export const assetMarketChartQuery = (req: GetAssetMarketChartRequest) =>
  queryOptions<
    GetAssetMarketChartRawResponse,
    Error,
    GetAssetMarketChartResponse
  >({
    queryKey: [ASSET_MARKET_CHART_DATA_KEY, req.chainId, req.denom, req.range],
    queryFn: () => getAssetMarketChart(req),
    staleTime: 60 * 1000, // 1 minute
    placeholderData: (previousData) => previousData, // Keep previous chart data visible while new token loads
    select: (data) => {
      let maxValue = -Infinity
      let minValue = Infinity

      const formatterFull = createDateFormatter('MMM dd, hh:mm')
      const formatterShort = createDateFormatter('MMM dd')

      const historicalData = new Array(data.prices.length)
      for (let i = 0; i < data.prices.length; i++) {
        const [time, value] = data.prices[i]

        if (value > maxValue) maxValue = value
        if (value < minValue) minValue = value

        historicalData[i] = {
          price: value,
          time: formatterFull.format(time),
          shortDate: formatterShort.format(time),
          timestamp: time,
        }
      }

      const first = historicalData[0].price
      const last = historicalData[historicalData.length - 1].price

      return {
        prices: historicalData,
        fetchedAt: data.fetched_at,
        maxValue,
        minValue,
        priceChange: ((last - first) / first) * 100,
      }
    },
  })
